<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content
	 class="info-content">
	<p>{{ data.content }}</p>
	<p *ngIf="data.content2 != undefined">{{ data.content2 }}</p>
	<mat-slide-toggle [(ngModel)]="messager.enable">
		<span class="mat-slide-toggle-content-extra">{{ 'LABEL_STORE_HTTP' | translate }}</span></mat-slide-toggle>
</div>
<div class="buttons-container"
	 mat-dialog-actions
	 [class.justify-content-end]="!!!data.cancelButtonLabel">
	<button *ngIf="!!data.cancelButtonLabel"
			class="dialog-button"
			mat-raised-button
			[color]="data.cancelButtonColor ?? 'primary'"
			[mat-dialog-close]="false"><span
		[class.text-white]="data.cancelButtonColor != 'basic' && data.cancelButtonColor != 'accent'">{{ data.cancelButtonLabel }}</span>
	</button>
	<button *ngIf="!!data.confirmButtonLabel"
			class="dialog-button"
			mat-raised-button
			[color]="data.confirmButtonColor ?? 'primary'"
			[mat-dialog-close]="true"><span
		[class.text-white]="data.confirmButtonColor != 'basic' && data.confirmButtonColor != 'accent'">{{ data.confirmButtonLabel }}</span>
	</button>
</div>
